class CartCount extends HTMLElement {
  constructor() {
    super();

    const setCount = (count) => {
      this.innerHTML = `
      <span aria-hidden="true">${count > 0 ? count : ""}</span>
      <span class="visually-hidden">${
        count === 1
          ? this.dataset.one
          : this.dataset.other.replace("[count]", count)
      }</span>`;
    };

    document.addEventListener("updateCart", (e) => {
      setCount(e.detail.cart.item_count);
    });
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
